import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "shareGoldFacebook",
  "use": "shareGoldFacebook-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"shareGoldFacebook\"><path d=\"m16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm4 10.9h-2.4c-.2 0-.6.4-.6 1v1.6h3v3h-3v7.3h-3v-7.3h-2.4v-3h2.4v-1.5c0-2.3 1.6-4 3.7-4h2.3z\" fill=\"#9c7446\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol